<script>
import { getRolename  }  from "@/helpers/helper"

export default {
  name: 'DetayModal',
  props:[
    "data"
  ],
  components: {
  },
  data() {
    return {
        title:'',
        url:'',
        submitted: false,
        odemeData:{},
        isLoading: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        pageLength: 0,
        columns:[
          {
            label: 'Kullanıcı Adı',
            field: 'username',
            sortable: false
          },
          {
            label: 'İşlem Tarih',
            field: 'created_at',
            sortable: false
          },
          {
            label: 'Ödeme Şekli',
            field: this.paymentType,
            sortable: false
          },
          {
            label: 'İşlem Açıklama',
            field: 'main_explaine',
            sortable: false
          },
          {
            label: 'Ücret',
            field: this.debt,
            sortable: false
          }
        ]
    }
  },
 watch:{
    data(props){
      this.title = `Ödeme Geçmişi > ${props.name}`
      this.url = `/accountant/detay`
      this.rows = []
      this.updateParams({'columnFilters':{ id : props.id, type_id:props.odemeTuru, startdate: props.startdate, startdateend:props.startdateend }})
      this.loadItems()
    }
  },
  computed:{
    rolename(){
      return getRolename()
    }
  },
  methods: {
    debt(obj){
        return obj.direction == 1 ? obj.amount : 0
    }, 
    paymentType(obj){
      let odemeSekli = ''

      if(!obj.payment_type_type) return

      switch (obj.payment_type_type) {
        case 'cek':
          odemeSekli = 'Çek'
          break;
        case 'kasa':
          odemeSekli = 'Nakit'
          break;
        case 'banka':
          odemeSekli = 'Kredi Kartı'
          break;
        case 'havale':
          odemeSekli = 'Havale'
          break;  
        case 'paylink':
          odemeSekli = 'PayLink'
          break;   
        default:
          odemeSekli = 'Veresiye'
          break;
      }
      return odemeSekli + ` (${obj.payment_type_title})`
    },
    credit(obj){
        return obj.direction == 2 ? obj.amount : 0
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
        return new Promise((resolve, reject) => {
            this.$http.post(this.url, this.serverParams)
            .then(res => {
                resolve({
                rows: res.data.data,
                totalRecords: res.data.total,
                pageLength: res.data.last_page,
                currentPage: res.data.current_page,
                })
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    
    close(){
      this.$parent.$bvModal.hide('detay_modal')
    },

    print(){
    
        const printContent = document.getElementById("printContent");
        const printWindow = window.open('', '', 'width=600,height=600');
        printWindow.document.open();
        printWindow.document.write('<html><head><title>Yazdır</title></head><body>');
        printWindow.document.write(printContent.innerHTML);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
    },

    odemeDuzeltOpen(props){
      this.odemeData = props
      this.$parent.$bvModal.show('odeme_duzelt')
    }
  },
};
</script>

<template>
  <b-modal id="detay_modal" size="xl" :title="title"  no-close-on-backdrop hide-footer>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{ enabled: false }"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
</b-modal>
</template>